export default __webpack_public_path__ + "static/media/logonav.312da23c.png";